// extracted by mini-css-extract-plugin
export default {"ticketsList":"TicketsList_ticketsList__Aevvj"};